import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '@/store';
import {
  selectPasswordUpdateStage,
  selectPasswordUpdateProgress,
  selectPasswordUpdateMessage,
  selectPasswordUpdateErrors,
  selectIsPasswordUpdateActive,
  resetPasswordUpdate,
} from '@/store/slices/passwordUpdate/passwordUpdateSlice';
import { updatePasswordThunk } from '@/store/thunks/auth/updatePasswordThunk';
import type { UpdatePasswordPayload } from '@/types/passwordUpdate/PasswordUpdate';

export function useUpdatePassword() {
  const dispatch = useAppDispatch();

  const stage = useSelector(selectPasswordUpdateStage);
  const { processed, total } = useSelector(selectPasswordUpdateProgress);
  const message = useSelector(selectPasswordUpdateMessage);
  const errors = useSelector(selectPasswordUpdateErrors);
  const isActive = useSelector(selectIsPasswordUpdateActive);

  const submit = useCallback(
    async(payload: UpdatePasswordPayload) => {
      await dispatch(updatePasswordThunk(payload));
    },
    [dispatch]
  );

  const reset = useCallback(() => {
    dispatch(resetPasswordUpdate());
  }, [dispatch]);

  return {
    state: {
      stage,
      message,
      processed,
      total,
      isActive,
      errors,
    },
    handlers: {
      submit,
      reset,
    },
  };
}
